// extracted by mini-css-extract-plugin
export var section = "section-module--section--YiRvb";
export var sectionDark = "section-module--section-dark--b3slL";